/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPORGANISATIONCLASSIFICATION } from './IAPORGANISATIONCLASSIFICATION';
import {
    IAPORGANISATIONCLASSIFICATIONFromJSON,
    IAPORGANISATIONCLASSIFICATIONFromJSONTyped,
    IAPORGANISATIONCLASSIFICATIONToJSON,
} from './IAPORGANISATIONCLASSIFICATION';
import type { IAPORGANISATIONSUBCLASSIFICATION } from './IAPORGANISATIONSUBCLASSIFICATION';
import {
    IAPORGANISATIONSUBCLASSIFICATIONFromJSON,
    IAPORGANISATIONSUBCLASSIFICATIONFromJSONTyped,
    IAPORGANISATIONSUBCLASSIFICATIONToJSON,
} from './IAPORGANISATIONSUBCLASSIFICATION';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface EntityClassificationViewModel
 */
export interface EntityClassificationViewModel {
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof EntityClassificationViewModel
     */
    isFinancialInstitution?: IAPYESORNO;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof EntityClassificationViewModel
     */
    hasGiinNumber?: IAPYESORNO;
    /**
     * 
     * @type {string}
     * @memberof EntityClassificationViewModel
     */
    giinNumber?: string;
    /**
     * 
     * @type {IAPORGANISATIONCLASSIFICATION}
     * @memberof EntityClassificationViewModel
     */
    organisationClassificationId?: IAPORGANISATIONCLASSIFICATION;
    /**
     * 
     * @type {IAPORGANISATIONSUBCLASSIFICATION}
     * @memberof EntityClassificationViewModel
     */
    organisationSubClassificationId?: IAPORGANISATIONSUBCLASSIFICATION;
    /**
     * 
     * @type {IAPORGANISATIONSUBCLASSIFICATION}
     * @memberof EntityClassificationViewModel
     */
    noGiinNumberReason?: IAPORGANISATIONSUBCLASSIFICATION;
}

/**
 * Check if a given object implements the EntityClassificationViewModel interface.
 */
export function instanceOfEntityClassificationViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EntityClassificationViewModelFromJSON(json: any): EntityClassificationViewModel {
    return EntityClassificationViewModelFromJSONTyped(json, false);
}

export function EntityClassificationViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityClassificationViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isFinancialInstitution': !exists(json, 'IsFinancialInstitution') ? undefined : IAPYESORNOFromJSON(json['IsFinancialInstitution']),
        'hasGiinNumber': !exists(json, 'HasGiinNumber') ? undefined : IAPYESORNOFromJSON(json['HasGiinNumber']),
        'giinNumber': !exists(json, 'GiinNumber') ? undefined : json['GiinNumber'],
        'organisationClassificationId': !exists(json, 'OrganisationClassificationId') ? undefined : IAPORGANISATIONCLASSIFICATIONFromJSON(json['OrganisationClassificationId']),
        'organisationSubClassificationId': !exists(json, 'OrganisationSubClassificationId') ? undefined : IAPORGANISATIONSUBCLASSIFICATIONFromJSON(json['OrganisationSubClassificationId']),
        'noGiinNumberReason': !exists(json, 'NoGiinNumberReason') ? undefined : IAPORGANISATIONSUBCLASSIFICATIONFromJSON(json['NoGiinNumberReason']),
    };
}

export function EntityClassificationViewModelToJSON(value?: EntityClassificationViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IsFinancialInstitution': IAPYESORNOToJSON(value.isFinancialInstitution),
        'HasGiinNumber': IAPYESORNOToJSON(value.hasGiinNumber),
        'GiinNumber': value.giinNumber,
        'OrganisationClassificationId': IAPORGANISATIONCLASSIFICATIONToJSON(value.organisationClassificationId),
        'OrganisationSubClassificationId': IAPORGANISATIONSUBCLASSIFICATIONToJSON(value.organisationSubClassificationId),
        'NoGiinNumberReason': IAPORGANISATIONSUBCLASSIFICATIONToJSON(value.noGiinNumberReason),
    };
}

